// src/AppRoutes.js
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./home";
import TikTokToe from "./tiktoktoe/TiktokToe"; // Add this import
import NotFound from "./404";
import LoadingSpinner from "./components/LoadingSpinner";
import "./styles/globals.css";

function AppRoutes() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tiktok-toe" element={<TikTokToe />} /> {/* Add this route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;